module.exports = __webpack_public_path__ + "static/media/spot_code.97d496f1.svg";